import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Form, Input } from 'reactstrap';

import {ReactComponent as XBUTTONPLAYERLIST} from '../xButtonListe.svg';

export default class ShareAlternative extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      error : '',
    };

  }


  componentDidMount(){
    navigator.clipboard.writeText(window.location.href);
  }


  render () {

    return (
      <React.Fragment>
      <div style={{backgroundColor:"#00000090", position:"fixed", top:"0", left:"0", width: "100%", height:"100%", zIndex:"10"}} >
        <div style={{position:"absolute", backgroundColor:"#FFF", top:"50%", left:"50%", width:"80%", maxWidth:"500px", margin:"0", transform:"translateY(-50%) translateX(-50%)", padding:"20px", display: "flex", flexDirection:"column", fontWeight: "bolder",color:"#0061ae"}}>
          <div style={{marginBottom:"20px"}}>
            <img src="/assets/branding/maxi_md_blue.png" alt="" style={{
              width:"60%",
              minWidth:"110px",
              maxWidth:"200px",
              height: "auto",
              objectFit: "cover"
            }}/>
            <XBUTTONPLAYERLIST id="xButtonPlayerList" style={{position:"absolute", width:"40px", height:"40px", top:"20px", right:"20px"}} onClick={this.props.close }/>
          </div>
          <div style={{marginBottom:"20px"}}>
            <h2 style={{fontWeight: "bolder"}}>PARTAGER</h2>
            <p>Le lien a été copié dans votre presse-papier</p>
            <Form>
              <Input type="text" name="link" id="link" value={window.location.href} style={{color:"#0061ae", fontWeight: "bold", textAlign:"center"}}/>
            </Form>
          </div>

        </div>
      </div>
      </React.Fragment>
    );
  }
}
